import {API} from '@utils'
import _ from "lodash"
import {GlobalListResponseVM} from "@cmodules/checklist/assets/data/types/vm/template-builder/global-list"

//************************************//
export function _getStructuresList({limit, page, sort, filter}: {limit: number, page: number, sort?: string, filter?: any}, callback: (data: any) => void): void {
	API.get('/resources/sites/structures/list', {
		params: {
			limit,
			page,
			sort,
			filter
		}
	})
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
}
//************************************//

export function _getAllStructures(callback: (data: any) => void, finishCallback = () => {}) {
	API.get(`/resources/sites/structures/all`)
		.then(function ({data}) {
			callback(data)
		})
		.catch(function (res) {})
		.finally(() => finishCallback())
}
//************************************//

export function _getStructureData(id: string, callback: (data: any) => void, finishCallback: () => void): void {
	API.get(`/resources/sites/structures/${id}`)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//

export function _addStructure(data: any, callback: (data: any) => void, finishCallback: () => void): void {
	API.post(`/resources/sites/structures/new`, data)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//
export function _archiveStructure(id: string, callback: (data: any) => void): void {
	API.delete(`/resources/sites/structures/${id}`)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
}
//************************************//

export function _updateStructure(id: string, data: any, callback: (data: any) => void, finishCallback: () => void): void {
	API.put(`/resources/sites/structures/${id}`, data)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//

export function _sendImportedData(id: string, data: any, callback: (data: any) => void, callbackErr: (data: any) => void, finishCallback: () => void): void {
	API.post(`/resources/sites/${id}/bulk-import`, data)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function ({data}: {data: any}) {
			callbackErr(data)
		})
		.finally(() => finishCallback())
}
//************************************//

export function _sendAssetsImportedFile(id: string, data: {file: File, columns: Record<string, any>}, callback: (data: any) => void, callbackErr: (data: any) => void, finishCallback: () => void): void {
	const formData = new FormData()
	formData.append('file', data.file)
	const finalColumns: Array<{id: string, index: any}> = []
	_.forEach(data.columns, (x, key) => {
		finalColumns.push({id: key, index: x})
	})
	formData.append('columns', JSON.stringify(finalColumns))
	// console.log(JSON.stringify(finalColumns))
	// return
	API.post(`/resources/sites/${id}/bulk-import-new`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function ({data}: {data: any}) {
			callbackErr(data)
		})
		.finally(() => finishCallback())
}
//************************************//

export function _getStructureSitesTreeData(id: string, callback: (data: any) => void, finishCallback: () => void = () => {}): void {
	API.get(`/resources/sites/structures/${id}/tree`)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//

export function _getStructureSitesListData(id: string, callback: (data: any) => void, finishCallback: () => void = () => {}): void {
	API.get(`/resources/sites/structures/${id}/sites`)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//

export function _getSitesList({limit, page, sort, filter}: {limit: number, page: number, sort?: string, filter?: any}, callback: (data: any) => void): void {
	API.get('/resources/sites/list', {
		params: {
			limit,
			page,
			sort,
			filter
		}
	})
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
}
//************************************//

export function _getSiteData(id: string, callback: (data: any) => void, finishCallback: () => void): void {
	API.get(`/resources/sites/${id}`)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//

export function _addSite(data: any, callback: (data: any) => void, finishCallback: () => void): void {
	API.post(`/resources/sites/new`, data)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//
export function _archiveSite(id: string, callback: (data: any) => void): void {
	API.delete(`/resources/sites/${id}`)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
}
//************************************//

export function _updateSite(id: string, data: any, callback: (data: any) => void, finishCallback: () => void): void {
	API.put(`/resources/sites/${id}`, data)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//

export function _getSiteChildren(id: string, callback: (data: any) => void, finishCallback: () => void): void {
	API.get(`/resources/sites/${id}/children`)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//

export function _getGlobalListsList({limit, page, sort, filter}: {limit: number, page: number, sort?: string, filter?: any}, callback: (data: any) => void): void {
	API.get('/resources/global-lists/list', {
		params: {
			limit,
			page,
			sort,
			filter
		}
	})
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
}
//************************************//

export function _getGlobalListData(id: string, callback: (data: any) => void, finishCallback: () => void = () => {}): void {
	API.get(`/resources/global-lists/${id}`)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//

export function _addGlobalList(data: any, callback: (data: any) => void, finishCallback: () => void): void {
	API.post(`/resources/global-lists/new`, data)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//
export function _archiveGlobalList(id: string, callback: (data: any) => void): void {
	API.delete(`/resources/global-lists/${id}`)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
}
//************************************//

export function _updateGlobalList(id: string, data: any, callback: (data: any) => void, finishCallback: () => void): void {
	API.put(`/resources/global-lists/${id}`, data)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//

export function _getGlobalListItems(id: string, {limit, page, sort, filter}: {limit: number, page: number, sort?: string, filter?: any}, callback: (data: any) => void): void {
	API.get(`/resources/global-lists/${id}/items`, {
		params: {
			limit,
			page,
			sort,
			filter
		}
	})
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
}
//************************************//

export function _addGlobalListItem(id: string, data: any, callback: (data: any) => void, finishCallback: () => void): void {
	API.post(`/resources/global-lists/${id}/items/new`, data)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//
export function _archiveGlobalListItem(id: string, itemId: string, callback: (data: any) => void): void {
	API.delete(`/resources/global-lists/${id}/items/${itemId}`)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
}
//************************************//

export function _updateGlobalListItem(id: string, itemId: string, data: any, callback: (data: any) => void, finishCallback: () => void): void {
	API.put(`/resources/global-lists/${id}/items/${itemId}`, data)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
		.finally(() => finishCallback())
}
//************************************//
export const _archiveBulkGlobalListItems = (uuid: string, data: any, callback: (data: any) => void): void => {
	API.put(`/resources/global-lists/${uuid}/items/bulk-archive`, data)
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function (res: any) {})
}
//************************************//
export const _restoreBulkGlobalListItems = (uuid: string, data: any, callback: (data: any) => void): void => {
	API.put(`/resources/global-lists/${uuid}/items/bulk-restore`, data)
	.then(function ({data}: {data: any}) {
		callback(data)
	})
	.catch(function (res: any) {})
}
//************************************//
export const _deleteUnusedCustomField = async (uuid: string, fieldId: string, callback?: (data: any) => void): Promise<any> => {
	const res = await API.delete(`/resources/global-lists/${uuid}/unused-fields/${fieldId}/delete`)
	return res.data
}
//************************************//
export const _getAllGlobalLists = (callback: (data: any) => void): void => {
  API.get('/resources/global-lists/all')
	.then(function ({data}: {data: any}) {
		callback(data)
	})
	.catch(function (res: any) {})
}
//************************************//
export const _getAllGlobalListsWithFields = (callback: (data: any) => void): void => {
  API.get('/resources/global-lists/all', {
		params: {
			with_fields: true
		}
	})
	.then(function ({data}: GlobalListResponseVM) {
		callback(data)
	})
	.catch(function () {})
}
//************************************//
export function _sendGlobalListImportedFile(global_list_id: string, data: {file: File, columns: Record<string, any>}, callback: (data: any) => void, callbackErr: (data: any) => void, finishCallback: () => void): void {
	const formData = new FormData()
	formData.append('file', data.file)
	const finalColumns: Array<{id: string, index: any}> = []
	_.forEach(data.columns, (x, key) => {
		finalColumns.push({id: key, index: x})
	})
	formData.append('columns', JSON.stringify(finalColumns))
	formData.append('list_id', global_list_id)
	// console.log(JSON.stringify(finalColumns))
	// return
	API.post(`/resources/global-lists/bulk-import`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
		.then(function ({data}: {data: any}) {
			callback(data)
		})
		.catch(function ({data}: {data: any}) {
			callbackErr(data)
		})
		.finally(() => finishCallback())
}

export function _getAllStructureInstances(callback: (data: any) => void, finishCallback: () => void = () => {}): void {
  API.get(`/resources/sites/instances`)
    .then(function ({data}: {data: any}) {
      callback(data)
    })
    .catch(function (res: any) {})
    .finally(() => finishCallback())
}

export function _getChildStructureDetails(id: string, callback: (data: any) => void, finishCallback: () => void = () => {}): void {
  API.get(`/resources/sites/structures/${id}/columns`)
    .then(function ({data}: {data: any}) {
      callback(data)
    })
    .catch(function (res: any) {})
    .finally(() => finishCallback())
}

export function _getSiteDetails(id: string, callback: (data: any) => void, finishCallback: () => void = () => {}): void {
  API.get(`/resources/sites/${id}`)
    .then(function ({data}: {data: any}) {
      callback(data)
    })
    .catch(function (res: any) {})
    .finally(() => finishCallback())
}

export function _addSiteInstance(data: any, callback: (data: any) => void, finishCallback: () => void = () => {}): void {
  API.post(`/resources/sites/new-instance`, data)
    .then(function ({data}: {data: any}) {
      callback(data)
    })
    .catch(function (res: any) {})
    .finally(() => finishCallback())
}

export function _editSite(id: string, data: any, callback: (data: any) => void, finishCallback: () => void = () => {}): void {
  API.put(`/resources/sites/${id}`, data)
    .then(function ({data}: {data: any}) {
      callback(data)
    })
    .catch(function (res: any) {})
    .finally(() => finishCallback())
}

export function _deleteStructureSite(structureId: string, nodeId: string, callback: (data: any) => void = () => {}, finishCallback: () => void = () => {}): void {
  API.delete(`/resources/sites/structures/${structureId}/node/${nodeId}`)
    .then(function ({data}: {data: any}) {
      callback(data)
    })
    .catch(function (res: any) {})
    .finally(() => finishCallback())
}

export const _searchSites = async ({q = '', parentId = '', ids = []}: {q?: string, parentId?: string, ids?: string[]} = {}): Promise<any> => {
  return await API.get(`/resources/sites/search`, {
    params: {
      q,
      parent_id: parentId,
      ids
    }
  })
  .catch(function (res: any) {})
}

export function _getGlobalLists({limit, page, sort, filter, withSavedQueries}: {limit: number, page: number, sort?: string, filter?: any, withSavedQueries?: boolean}, callback: (data: any) => void): void {
  API.get(`/resources/global-lists`, {
    params: {
      limit,
      page,
      sort,
      filter,
      with_saved_queries: withSavedQueries
    }
  })
  .then(function ({data}: {data: any}) {
    callback(data)
  })
  .catch(function (res: any) {})
}

export function _getArchivedGlobalLists({limit, page, sort, filter, withSavedQueries}: {limit: number, page: number, sort?: string, filter?: any, withSavedQueries?: boolean}, callback: (data: any) => void): void {
  API.get(`/resources/global-lists/archive`, {
    params: {
      limit,
      page,
      sort,
      filter,
      with_saved_queries: withSavedQueries
    }
  })
  .then(function ({data}: {data: any}) {
    callback(data)
  })
  .catch(function (res: any) {})
}

export const _getGlobalListsItems = (uuid: string, {limit, page, sort, filter, withSavedQueries}: {limit: number, page: number, sort?: string, filter?: any, withSavedQueries?: boolean}, callback: (data: any) => void): void => {
  API.get(`/resources/global-lists/${uuid}/items`, {
    params: {
      limit,
      page,
      sort,
      filter,
      with_saved_queries: withSavedQueries
    }
  })
  .then(function ({data}: {data: any}) {
    callback(data)
  })
  .catch(function (res: any) {})
}

export function _getArchivedGlobalListsItems(uuid: string, {limit, page, sort, filter, withSavedQueries}: {limit: number, page: number, sort?: string, filter?: any, withSavedQueries?: boolean}, callback: (data: any) => void): void {
  API.get(`/resources/global-lists/${uuid}/items/archive`, {
    params: {
      limit,
      page,
      sort,
      filter,
      with_saved_queries: withSavedQueries
    }
  })
  .then(function ({data}: {data: any}) {
    callback(data)
  })
  .catch(function (res: any) {})
}

export function _getGlobalList(uuid: string, callback: (data: any) => void): void {
  API.get(`/resources/global-lists/${uuid}`)
    .then(function ({data}: {data: any}) {
      callback(data)
    })
    .catch(function (res: any) {})
}

export const _getAsyncGlobalList = async (uuid: string): Promise<any> => {
  const {data} = await API.get(`/resources/global-lists/${uuid}`)
  return data
}

export const _restoreGlobalListItem = (uuid: string, itemId: string, callback: (data: any) => void): void => {
  API.put(`/resources/global-lists/${uuid}/items/${itemId}/restore`)
    .then(function ({data}: {data: any}) {
      callback(data)
    })
    .catch(function (res: any) {})
}

export const _restoreGlobalList = (uuid: string, callback: (data: any) => void): void => {
  API.put(`/resources/global-lists/${uuid}/restore`)
  .then(function ({data}: {data: any}) {
    callback(data)
  })
  .catch(function (res: any) {})
}

export const _restoreBulkGlobalList = (data: any, callback: (data: any) => void): void => {
  API.put(`/resources/global-lists/bulk-restore`, data)
  .then(function ({data}: {data: any}) {
    callback(data)
  })
  .catch(function (res: any) {})
}

export function _getStructureSitesData({limit, page, sort, filter, structureId}: {limit: number, page: number, sort?: string, filter?: any, structureId: string}, callback: (data: any) => void): void {
  API.get(`/resources/sites/structures/${structureId}`, {
    params: {
      limit,
      page,
      sort,
      filter
    }
  })
    .then(function ({data}: {data: any}) {
      callback(data)
    })
    .catch(function (res: any) {})
}
